export const NAME = 'producedProduction-common';

export const dialogs = {
	wrongReportDateFrom: 'wrongReportDateFrom',
};

export const productionStatuses = {
	NEW: 1,
	VALID: 2,
	CLOSED: 3,
};
